var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"announcement-mob-pure"},[_c(_setup.SharedMobFull)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }